





































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import {HealthPropadandaList,ClearResource} from "../../api/healthPropaganda"
import ECharts from 'vue-echarts'
import allPatient from './allPatient.vue'
import detailPatient from './detailPatient.vue'
import registerTheme from './registerTheme'
import {GetIndexUpData} from '../../api/realTime'

@Component({
    components: {ECharts,allPatient,detailPatient}
})
export default class extends AbpBase {
    get height(){
        return window.innerHeight-150
    }
    tabs:any = [
        {closable:false,key:0,name:'主页'},
        {closable:false,key:0,name:'全部患者'},
    ]
    activeName = '主页'
    //详细患者数据
    detailData:any = {}
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
        this.getDetailData()
    }
    //tabs切换方法
    activeNameChange(val:any){
        if(this.activeName !== '主页' && this.activeName !== '全部患者'){
            this.getDetailData()
        }
    }
    getDetailData(){
        this.detailData = this.tabs.find((item:any)=>{
            return item.name == this.activeName
        })
    }
    getDetail(row:any,tenantId:any){
        this.tabs.push({
            closable:true,
            key:1,
            name:row.patientName,
            ...row,
            tenantId:tenantId
        })
        this.activeName = row.patientName
        this.getDetailData()
    }
    created() {
        ECharts.registerTheme('ECharts',registerTheme)
        this.getIndexUpData() 
    }
    async getIndexUpData(){
        let res = await GetIndexUpData({})
        this.loadCharts(res.data)
    }
    option1:any = {}
    option2:any = {}
    option3:any = {}
    option4:any = {}
    //生成图表
    loadCharts(data:any){
        let vm = this;
        //床位占用率
        var sickBeds_x = [];
        var sickBeds_y = [];
        var sickBeds_y2 = [];
        var sickBeds_y3 = [];
        if (data.sickbeds != null) {
            for (var i = 0; i < data.sickbeds.length; i++) {
                sickBeds_x.push(data.sickbeds[i].tenantName);
                sickBeds_y.push((data.sickbeds[i].bedEmptyPercent*100).toFixed(2));
                sickBeds_y2.push(data.sickbeds[i].bedUsedCount);
                sickBeds_y3.push(data.sickbeds[i].bedEmptyCount);
            }
            vm.option1 = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            
                        type: 'shadow'        
                    }
                },
                title: {
                    text: '空床率',
                    padding: 16,
                    textStyle: {
                        fontSize: 16,
                        fontFamily: 'MicrosoftYaHei',
                        fontWeight: 'normal'
                    }
                },
                legend:{
                    data: ['空床数', '使用床数', '空床率'],
                    right: 20,
                    top: 10
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '5%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: sickBeds_x,
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '张',
                        nameTextStyle: {
                            color: '#ffffff',
                            fontSize: 14,
                        },
                    }
                ],
                series: [
                    {
                        name: '空床数',
                        type: 'bar',
                        stack: '总量',
                        barWidth: '40%',
                        label: {
                            normal: {
                                show: true,
                                position: 'inside',
                                color: '#fff',
                            }
                        },
                        data: sickBeds_y3
                    },{
                        name: '使用床数',
                        type: 'bar',
                        stack: '总量',
                        barWidth: '40%',
                        label: {
                            normal: {
                                show: true,
                                position: 'inside',
                                color: '#fff',
                            }
                        },
                        data: sickBeds_y2
                    },{
                        name: '空床率',
                        type: 'line',
                        stack: '总量',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    position: 'top',
                                    color: '#fff',
                                    formatter: '空床率 : {c} %'
                                }
                            }
                        },
                        data: sickBeds_y
                    }

                ]
            };
        }
        //耗材使用量
        var countSupplies_x = [];
        var countSupplies_legend = ['其他','护理包','生理盐水','穿刺针','血路管','透析器','透析液统计'];
        var series2 = [];
        vm.option2 = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            title: {
                text: '耗材额外用量',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                },
            },
            legend: {
                data: countSupplies_legend,
                right: 20,
                top: 10
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: sickBeds_x
            },
            yAxis: {
                type: 'value',
                name: '数量',
                nameTextStyle: {
                    color: '#ffffff',
                    fontSize: 14,
                },
            },
        };
        for(var i = 0; i<7;i ++){
            series2.push({
                name:countSupplies_legend[i],
                data:[0,0,0,0,0,0,0],
                type:'bar',
                label: {
                    normal: {
                        show: true,
                        position: 'inside',
                        color: '#fff',
                    }
                },
            })
        }
        vm.option2.series = series2;
        //并发症发生率
        var percents_x = [];
        var percents_y = [];
        if (data.percents != null) {
            for (var i = 0; i < data.percents.length; i++) {
                percents_x.push(data.percents[i].tenantName);
                percents_y.push(data.percents[i].complicationsPercents);
            }
            vm.option3 = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                title: {
                    text: '并发症发生率',
                    padding: 16,
                    textStyle: {
                        fontSize: 16,
                        fontFamily: 'MicrosoftYaHei',
                        fontWeight: 'normal'
                    },
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '5%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: percents_x,
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '%',
                        nameTextStyle: {
                            color: '#ffffff',
                            fontSize: 14,
                        },
                    }
                ],
                series: [
                    {
                        //name: '直接访问',
                        type: 'bar',
                        barWidth: '40%',
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                color: '#fff',
                            }
                        },
                        data: percents_y
                    }
                ]
            };
        }
        //透析例次
        var series4 = [];
        function getCount(code,list) {
            let count = 0;
            list.forEach((item:any)=>{
                if(item.itemCode == code){
                    count = item.count
                }
            })
            return count
        }
        if (data.dialysisModels != null) {
            data.dialysisModels.forEach((item:any)=>{
                let dataList = data.dataListType.map((v:any)=>{
                    return {
                        count:getCount(v,item.dataList),
                        itemCode:v
                    }
                })
                item.dataList = dataList
            })
            data.dataListType.forEach((item:any,index:any)=>{
                let sdata = data.dialysisModels.map((v:any)=>{
                    return v.dataList[index].count
                })
                console.log(sdata,'sdata')
                series4.push({
                    name: item,
                    data: sdata,
                    type: 'bar',
                    stack: '2',
                    barWidth: '40%',
                    label: {
                        normal: {
                            show: true,
                            color: '#fff',
                        }
                    }
                });
            })
            vm.option4 = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {

                        type: 'shadow'
                    }
                },
                title: {
                    text: '透析例次',
                    padding: 16,
                    textStyle: {
                        fontSize: 16,
                        fontFamily: 'MicrosoftYaHei',
                        fontWeight: 'normal'
                    },
                },
                legend: [
                    {
                        data: data.dataListType,
                        right: 20,
                        top: 10
                    },
                ],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '5%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: data.dialysisModels.map((item:any)=>{return item.tenantName}),
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '人数',
                        nameTextStyle: {
                            color: '#ffffff',
                            fontSize: 14,
                        },
                    }
                ],
            };
            vm.option4.series = series4;
        }
        function isRepeat(array, v) {
            var flag = false;
            for (var i = 0; i < array.length; i++) {
                var vv = array[i];
                if (vv.name == v) {
                    flag = true;
                }
            }
            return flag;
        }

        function getArray(array, v) {
            var result = null;
            for (var i = 0; i < array.length; i++) {
                var vv = array[i];
                if (vv.name == v) {
                    result = vv;
                }
            }
            return result;
        }
        console.log(vm.option1)
    }
}
